// extracted by mini-css-extract-plugin
module.exports = {"separatorText":"JoinButton_separatorText__DV559","buttons":"JoinButton_buttons__5ynly"};